import { render, staticRenderFns } from "./ProfileActionInvite.vue?vue&type=template&id=61e31964&"
import script from "./ProfileActionInvite.vue?vue&type=script&lang=js&"
export * from "./ProfileActionInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports